module.exports = __webpack_public_path__ + "img/pet.e1544a74.webp";